export const resetState = {
    RESET:'RESET_STATE'
}
export const toadyData = {
    LOAD: 'LOAD',
    REMOVE_LOAD: 'REMOVE_LOAD',
    LOADTWO: 'LOADTWO',
    REMOVE_LOADTWO: 'REMOVE_LOADTWO'
}
export const loginDetails = {
    LOGINUSER: 'LOGINUSER'
}

export const collectiveData = {
    LOAD: 'MULTIPLE_LOAD'
}

export const houseData = {
    LOADHOUSE: 'LOADHOUSE',
    ADD:'ADD_HOUSE',
    UPDATE:'UPDATE_HOUSE',
}

export const housesList = {
    LOADHOUSE_DATA: 'LOADHOUSE_DATA'
}

export const selectedDate = {
    LOAD_SELECTED_DATE: 'LOAD_SELECTED_DATE',
    LOAD_SELECTED_END_DATE: 'LOAD_SELECTED_END_DATE'
}

export const selectedHouseData = {
    LOAD_SELECTED_HOUSE_DATA: 'LOAD_SELECTED_HOUSE_DATA'
}

export const selectedRoomData = {
    LOAD_SELECTED_ROOM_DATA: 'LOAD_SELECTED_ROOM_DATA'
}

// The dashboard's Device Type pick (a selection.js group key).
export const selectedDeviceTypeData = {
    LOAD_SELECTED_DEVICE_TYPE: 'LOAD_SELECTED_DEVICE_TYPE'
}

export const selectedRoomAllDevices = {
    LOAD_SELECTED_ROOM_DEVICES: 'LOAD_SELECTED_ROOM_DEVICES'
}

export const selectedDeviceData = {
    LOAD_SELECTED_DEVICE_DATA: 'LOAD_SELECTED_DEVICE_DATA'
}

export const clearDropdownData = {
    CLEAR_DATA: 'CLEAR_DATA'
}

export const snapshotDailyUnit = {
    LOAD: "LOAD_DAILY_UNIT_SNAPSHOT",
    // UPDATE:"UPDATE_DAILY_UNIT_SNAPSHOT",
}

export const scheduleType = {
    CREATE:'SCHEDULE_CREATE',
    UPDATE:'SCHEDULE_UPDATE',
    FETCH:'SCHEDULE_FETCH',
    REMOVE:'SCHEDULE_REMOVE',
    ENABLE:'SCHEDULE_ENABLE',
    ALLREMOVE:'ALL_SCHEDULE_REMOVE',

}
export const reportTypes ={
    ADD_UNIT:'ADD_UNIT',
    UPDATE_CALL_COUNT:'UPDATE_CALL_COUNT',
}

export const weatherSensorsAction={
    "LOAD":'LOAD_WEATHER_SENSORS'
}

export const thermoSmartsAction={
    "LOAD": 'LOAD_THERMO_SMART'

}

export const environSyncsAction={
    "LOAD":'LOAD_ENVIRNO_SYNC'

}

export const deviceScheduleData = {
    MERGE: 'MERGE_DEVICE_SCHEDULE'
}

export const deviceMasterData = {
    MERGE: 'MERGE_DEVICE_MASTER'
}

export const storeMasterData = {
    MERGE: 'MERGE_STORE_MASTER'
}

export const vrvTypes = {
    LOAD_GATEWAYS: 'VRV_LOAD_GATEWAYS',
    SELECT_GATEWAY: 'VRV_SELECT_GATEWAY',
    LOAD_IDUS: 'VRV_LOAD_IDUS',
    SET_LOADING_GATEWAYS: 'VRV_SET_LOADING_GATEWAYS',
    SET_LOADING_IDUS: 'VRV_SET_LOADING_IDUS',
    SET_COMMAND_LOADING: 'VRV_SET_COMMAND_LOADING',
    SET_BULK_COMMAND_LOADING: 'VRV_SET_BULK_COMMAND_LOADING',
    UPDATE_IDU: 'VRV_UPDATE_IDU',
    BULK_UPDATE_IDUS: 'VRV_BULK_UPDATE_IDUS',
    LOAD_SCHEDULES: 'VRV_LOAD_SCHEDULES',
    ADD_SCHEDULE: 'VRV_ADD_SCHEDULE',
    SET_LOADING_SCHEDULES: 'VRV_SET_LOADING_SCHEDULES',
    DELETE_SCHEDULE: 'VRV_DELETE_SCHEDULE',
    TOGGLE_SCHEDULE: 'VRV_TOGGLE_SCHEDULE',
    UPDATE_SCHEDULE: 'VRV_UPDATE_SCHEDULE',
}